import React from 'react';  // Import React
 
import Header from './Header';
// import { imageAssets } from '../../utils/Resources';
 
 
const Layout = ({ children, pageName }) => {  
    return (
        <div className="container-fluid">
        <div className="position-relative bg-aliceblue bg-border-radius h-calc-20 mt-2">
            <Header active={pageName} />
 
            {children}
        </div>
        </div>
    );
}    
 
export default Layout;      